<div class="col-12 col-md-12 protean-device-list">
  <div class="table-fixed-tbody">
    <table class="table table-hover ng-table table-fixed-col">
      <thead>
        <tr>
          @for (column of columns; track column; let i = $index) {
            @if (column.selected) {
              <th class="header sortable"
                [ngClass]="this.transformedColumns[i].sort"
                [title]="this.transformedColumns[i].sort"
                (click)="sortBy(column, this.rows,this.transformedColumns[i])"
                style="width: 20%; cursor: pointer; background-color:rgb(0, 43, 111); color: white;">
                <div style="cursor: pointer; white-space: nowrap;">{{ columnDefinitions[column.name].title}}</div>
              </th>
            }
          }
        </tr>
      </thead>
      <tbody>

      </tbody>
    </table>
  </div>
</div>

<app-device-list-empty tracker="tracker"></app-device-list-empty>
<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>
<ng-template #alerttemplateSocketLost let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Reload()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>